module.exports = __webpack_public_path__ + "img/icon-right.fdba9add.svg";